import React, { useEffect, useState, useRef } from "react";
import Helper from "helper/Common_Helper";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useLocation } from 'react-router-dom';
import Header from 'Components/HeaderPlain';
import axiosConn from "config/axiosConn";
import { useDispatch, useSelector } from 'react-redux';
// import SpinnerOverlay from "../Components/SchoolAdmin/Spinner";

dayjs.extend(isSameOrAfter);

function ParticipantList({ TableData }) {
    const location = useLocation();
    const [eventsData, setEventsData] = useState([]);
    const today = dayjs().startOf('day');
    const hasFetchedTotal = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const dispatch = useDispatch();
    const userData = useSelector(state => state.auth.user);
    const [udise, setUDISE] = useState();

    const params = new URLSearchParams(location.search);
    let storedState = params.get('state');

    if (location.pathname.includes('admin') && !location.pathname.includes('admin/state-level')) {
        storedState = null;
    } else if (location.pathname.includes('admin/state-level') && (!storedState || storedState === 'null')) {
        storedState = localStorage.getItem('filterDataState');
    }

    useEffect(() => {
        if (userData) {
            getStateList({ state: storedState }, 1);
        }
    }, [storedState]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    scrollToTop();

const downloadCSV = async () => {
    try {
        setLoading(true);

        const response = await axiosConn(
            'post',
            "ekped-allrecords",
            { state: storedState, page: 1, limit: 100000 },
            {},
            dispatch
        );

        const allData = response?.data?.records?.records || [];

        if (!Array.isArray(allData) || allData.length === 0) {
            alert("No data available to download.");
            return;
        }

        const headers = [
            "S.no",
            "UDISE ID",
            "School Name",
            "Student Name",
            "Father's Name",
            "Mother's Name",
            "Gender",
            "Age",
            "Class",
            "State/UT/AB",
            "District"
        ];

        const rows = allData.map((item, index) => [
            index + 1,
            `"${item.udise_id || 'N/A'}"`,
            `"${item.school_data?.schooName || '-'}"`,
            `"${item.student_name || '-'}"`,
            `"${item.fatherName || '-'}"`,
            `"${item.motherName || '-'}"`,
            `"${item.gender || '-'}"`,
            `"${item.age || '-'}"`,
            `"${item.class || '-'}"`,
            `"${item.school_data?.eduStateName || '-'}"`,
            `"${item.school_data?.eduDistrictName || '-'}"`
        ]);

        const csvContent = "\uFEFF" + [headers, ...rows].map(e => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `participant_list_${storedState || 'all'}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

    } catch (error) {
        console.error("Error while downloading CSV:", error);
        alert("Something went wrong while downloading the CSV.");
    } finally {
        setLoading(false);
    }
};




    

const getStateList = async (data, page = 1) => {
    try {
        setLoading(true);

        const requestData = {
            ...data,
            page,
            limit: 10,
        };

        const response = await axiosConn('post', "ekped-allrecords", requestData, {}, dispatch);
        console.log("API Response:", response);

        if (response.data.status === "success") {
            const eventList = response.data.records; // Directly access the array

            if (Array.isArray(eventList)) {
                setEventsData(eventList);

                // Uncomment and update these if the API response includes them
                // setTotalPages(Math.ceil(response.data.totalCount / 10));
                // setCurrentPage(page);
                // setUniqueUdiseCount?.(response.data.uniqueUdiseCount);
            } else {
                console.warn("Unexpected data format:", eventList);
            }
        } else {
            console.warn("API returned unsuccessful status:", response.data);
        }
    } catch (error) {
        console.error("API Error:", error);
    } finally {
        setLoading(false);
    }
};





    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            getStateList({ state: storedState }, page);
        }
    };

    return (
        <>
        {/* {loading && <SpinnerOverlay />} */}
        {/* <Header /> */}
        <div className="content">
            <div className="btmTableDivIn">
                <div className="tableTopDiv">
                    <div className="dwnldexel" style={{ marginBottom: '1rem' }}>
                        <button className="btn btn-primary" onClick={downloadCSV}>Download CSV</button>
                    </div>
                    <h3 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                        {/* StateWise Onboarded Schools Details - {storedState} */}
                        Number of Students Participated
                    </h3>
                    <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        {!loading ? (
                            <table rules="all" className="table">
                                <thead className="text-primary" style={{
                                    position: 'sticky',
                                    top: '0',
                                    backgroundColor: '#ffffff',
                                    zIndex: '1000',
                                    boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'
                                }}>
                                    <tr className="tblHdngOne">
                                          <th>S.no</th>
                            <th>UDISE_ID</th>
                            <th>School Name</th>
                            <th>Student Name</th>
                            <th>Father's Name</th>
                            <th>Mother's Name</th>
                            <th>Gender</th>
                            <th>Age</th>
                            <th>Class</th>
                            <th>State/UT/AB</th>
                            <th>District</th>
                            {/* <th>Block/Ward no.</th> */}
                            {/* <th>City</th> */}
                            {/* <th>No. of Students</th> */}
                            {/* <th>No. of Trees</th> */}
                            {/* <th>Participating Schools</th> */}
                            {/* <th>Certificates Generated</th> */}
                            {/* <th>Created At</th> */}
                                    </tr>
                                </thead>
                               <tbody>
{eventsData.length > 0 ? (
    eventsData.map((item, i) => (
        <tr key={i}>
            <td>{(currentPage - 1) * 10 + i + 1}</td>
            <td>{item.udise_id || 'N/A'}</td>
            <td>{item.school_data?.schooName || '-'}</td>
            <td>{item.student_name || '-'}</td>
            <td>{item.fatherName || '-'}</td>
            <td>{item.motherName || '-'}</td>
            <td>{item.gender || '-'}</td>
            <td>{item.age || '-'}</td>
            <td>{item.class || '-'}</td>
            <td>{item.school_data?.eduStateName || '-'}</td>
            <td>{item.school_data?.eduDistrictName || '-'}</td>
            {/* <td>{item.school_data?.eduBlockName || '-'}</td> */}
            {/* <td>{item.city || '-'}</td> */}
            
            {/* <td>{item.numberOfStudents || 0}</td> */}
            {/* <td>{item.numberOfTrees || 0}</td> */}
            {/* <td>{item.participatingSchools || 0}</td> */}
            {/* <td>{item.certificatesGenerated || 0}</td> */}
            {/* <td>{Helper.formatDate(item.created_at)}</td> */}
        </tr>
    ))
) : (
    <tr>
        <td colSpan={11} className="text-center">Data not Found.</td>
    </tr>
)}

</tbody>

                            </table>
                        ) : null}
                    </div>
                    {!loading && totalPages > 1 && (
                        <div className="mb-3 text-center">
                            <button
                                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1); }}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span style={{ margin: '0 10px' }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1); }}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
    
    );
}

export default ParticipantList;
